<template>
  <div class="selfCar">
    <div v-wechat-title='$route.meta.title'></div>

    <EZUIKitJs />

    <div class="vehicle-box">
      <div class="vehicle-box-title">车辆信息</div>
      <div class="vehicle-box-info">
        <div class="vehicle">{{roadData.name}}</div>
        <div class="vehicle">{{vehicle}}</div>
        <div>
          <van-tag type="success" size="large">手工装车</van-tag>
        </div>
      </div>
    </div>

    <div class="car-info-box">
      <div class="fx-btn">
        <div class="ss-btn all-btn" :class="{active1: isActive == 1}" @touchstart="riseStart" @touchend="riseEnd">
          <div class="triangle"></div>
        </div>
      </div>
      <div class="middle-btn">
        <div class="qd-btn all-btn" :class="{active1: isActive2 == 1}" @click="start">
          <van-icon size="24" class="btn-icon" name="play-circle-o" /><span style="vertical-align: middle;">启动</span>
        </div>
        <div class="tz-btn all-btn" :class="{active1: isActive2 == 2}" @click="stop">
          <van-icon size="24" class="btn-icon" name="stop-circle-o" /><span style="vertical-align: middle;">停止</span>
        </div>
      </div>
      <div class="fx-btn">
        <div class="xj-btn all-btn" :class="{active1: isActive == 2}" @touchstart="dropStart" @touchend="dropEnd">
          <div class="triangle1"></div>
        </div>
      </div>
    </div>

    <div class="vehicle-box">
      <div class="vehicle-box-title">语音提示</div>
      <div class="voice_box">
        <div class="voice_btn ss-btn" :class="{active1: isActive3 == 1}" @click="forward">前进</div>
        <div class="voice_btn xj-btn" :class="{active1: isActive3 == 2}" @click="back">后退</div>
        <div class="voice_btn tz-btn" :class="{active1: isActive3 == 3}" @click="parking">停车</div>
      </div>
    </div>
  </div>
</template>

<script>
import EZUIKitJs from "../../components/EZUIKitJs.vue";
export default {
  name: "selfCarApp",
  components: {
    EZUIKitJs,
  },
  data() {
    return {
      isActive: 0,
      isActive2: 0,
      isActive3: 0,
      code: "",
      roadData: {},
      vehicle: ''
    };
  },

  created() {
    this.code = this.$route.query.code;
    this.$nextTick(function () {
      this.getCodeInfo(this.code);
    });
  },

  destroyed() {
    console.log("离开页面");
    this.socketApi.webSocketClose();
  },

  methods: {
    async getCodeInfo(code) {
      const { data: res } = await this.$http.get("ymt/laneregister/page", {
        params: {
          qrCode: code,
        },
      });
      console.log(res);

      if (res.code == 0 && res.data.records.length > 0) {
        this.roadData = res.data.records[0];

        //建立socket连接
        const websocketIP = "ws://" + this.roadData.webSocket;
        this.socketApi.initWebSocket(websocketIP).then((res) => {
          console.log(res, "res");
        });
        this.websocketSend({});
      } else {
        this.$toast({
          message: "未配置车道信息",
          duration: 1000,
        });
      }
    },

    // 接收socket回调函数返回数据的方法
    getConfigResult(res) {
      console.log(res, "硬件数据"); //硬件返回的数据
      if (res.code == 0) {
        this.$toast({
          message: res.msg,
          duration: 2000
        })
      } else if (res.code == 1) {
        this.$toast({
          message: res.msg,
          duration: 2000,
        });
      } else if (Object.prototype.toString.call(res) == '[object Array]') {
         let obj = res.find(x => x.place == this.roadData.placeId)
          console.log(obj)
          if (obj != undefined) {
            this.vehicle = obj.vehicle
          }
      } else if (Object.prototype.toString.call(res) == '[object Object]') {
        this.vehicle = res.vehicle
      } else {
        this.socketApi.webSocketClose();
      }
     
    },

    websocketSend(data) {
      //data为要发送的数据，this.getConfigResult为回调函数，用于在此页面接收socket返回的数据。
      this.socketApi.sendSock(data, this.getConfigResult);
    },

    clickCla (id) {
      this.claId = id
      console.log(id)
    },

    riseStart() {
      this.isActive = 1;
      let data = {
        place: this.roadData.placeId,
        type: "up",
        info: "1"
      };
      this.websocketSend(data);
    },
    riseEnd() {
      this.isActive = 0;
      let data = {
        place: this.roadData.placeId,
        type: "up",
        info: "0"
      };
      this.websocketSend(data);
    },
    dropStart() {
      this.isActive = 2;
      let data = {
        place: this.roadData.placeId,
        type: "down",
        info: "1"
      };
      this.websocketSend(data);
    },
    dropEnd() {
      this.isActive = 0;
      let data = {
        place: this.roadData.placeId,
        type: "down",
        info: "0"
      };
      this.websocketSend(data);
    },
    start() {
      this.isActive2 = 1;
      let data = {
        place: this.roadData.placeId,
        type: 'start'
      }
      this.websocketSend(data)
    },
    stop() {
      this.isActive2 = 2;

      let data = {
        place: this.roadData.placeId,
        type: 'stop'
      }
      this.websocketSend(data)
    },

    forward() {
      this.isActive3 = 1;

      let data = {
        place: this.roadData.placeId,
        type: 'warn',
        info: 1
      }
      this.websocketSend(data)
    },

    back() {
      this.isActive3 = 2;

      let data = {
        place: this.roadData.placeId,
        type: 'warn',
        info: 2
      }
      this.websocketSend(data)
    },

    parking() {
      this.isActive3 = 3;

      let data = {
        place: this.roadData.placeId,
        type: 'warn',
        info: 3
      }
      this.websocketSend(data)
    },
  },
};
</script>


<style lang="less" scoped>
* {
  -webkit-touch-callout:none; /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
}
.selfCar {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  .vehicle-box {
    margin: 0.1rem;
    box-shadow: 0 0.1rem 0.2rem 0 #e6e6e6;

    .vehicle {
      font-weight: bold;
      font-size: 0.16rem;
    }
  }

  .vehicle-box-info {
    display: flex;
    justify-content: space-between;
    border: 0.01rem solid #dde3f1;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.15rem;
    background-color: #fff;
  }

  .vehicle-box-title {
    height: 0.32rem;
    line-height: 0.32rem;
    background-color: #3a3f56;
    color: #fff;
    font-weight: bold;
    padding-left: 0.1rem;
  }

  .car-info-box {
    margin: 0.1rem 0.1rem;
    // border: .01rem solid #e6e6e6;
    padding: 0.2rem 0.15rem;
    background-color: #3a3f56;
    color: #fff;
    // box-shadow: 0 .1rem .2rem 0 #999595;
  }
}

.middle-btn {
  // width: 80%;
  display: flex;
  margin: 0.2rem auto;
  justify-content: space-between;
}

.all-btn {
  width: 0.48rem;
  height: 0.48rem;
  line-height: 0.32rem;
  font-size: 0.16rem;
  background-color: #1989fa;
  color: #fff;
  margin: auto;
  border-radius: 0.48rem;
  text-align: center;
  box-shadow: 0 0.1rem 0.2rem 0 #1d2136;
}

.voice_btn {
  width: 0.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.16rem;
  background-color: #1989fa;
  color: #fff;
  margin: auto;
  border-radius: 0.05rem;
  text-align: center;
}

.ss-btn {
  background-color: #1989fa;
  border: 1px solid #1989fa;
}

.xj-btn {
  background-color: #ff976a;
  border: 1px solid #ff976a;
}

.qd-btn {
  width: 0.8rem;
  height: 0.4rem;
  // line-height: .4rem;
  padding-top: 0.02rem;
  background-color: #07c160;
  border: 1px solid #07c160;
}

.tz-btn {
  width: 0.8rem;
  height: 0.4rem;
  // line-height: .4rem;
  padding-top: 0.02rem;
  background-color: #ee0a24;
  border: 1px solid #ee0a24;
}

.active1 {
  opacity: 0.7 !important;
}

.voice_box {
  display: flex;
  justify-content: space-around;
  padding: 0.2rem 0;
}

.triangle {
  width: 0;
  height: 0;
  border-top: 0.2rem solid transparent;
  border-right: 0.15rem solid transparent;
  border-bottom: 0.2rem solid #fff;
  border-left: 0.15rem solid transparent;
  margin: 0 auto;
  margin-top: -0.1rem;
  border-radius: 0.03rem;
}

.triangle1 {
  width: 0;
  height: 0;
  border-top: 0.2rem solid #fff;
  border-right: 0.15rem solid transparent;
  border-bottom: 0.2rem solid transparent;
  border-left: 0.15rem solid transparent;
  margin: 0 auto;
  margin-top: 0.15rem;
  border-radius: 0.03rem;
}

.btn-icon {
  vertical-align: middle;
  margin-right: 0.05rem;
}

</style>